export const config = {
  "logo": "../../logo.svg",
  "logoSmall": "../../logoSmall.png",
  "copyWhite": "../../copyWhite.svg",
  "copyBlack": "../../copy.svg",
  "apiLogo": "../../apiLogo.svg",
  "favicon": "../../favicon.ico",
  "manifest": "../../manifest.json",
  "theme": {
    "colors": {
      "primary": "#DC3C3A",
      "secondary": "#23262A",
      "tertiary":"#1F4AAD",
      "quaternary":"#F7DA49",
      "error": "#DC3C3A"
    }
  }
};

